import { bfsUserWebHttp, otmsHttp } from '@/utils/http/index';

/**
 * @description 用户身份信息查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/19713
 */
export function getUnifyUserInfo(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/identity/info', data, {
    params,
  });
}

/**
 * @description 获取列表
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/25841
 */
export function getOdooAccount(data, params) {
  return bfsUserWebHttp.post('/bfs_user/odoo_account/list', data, {
    params,
  });
}
/**
 * @description 统一用户分页查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/19713
 */
export function getUnifyUserPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/page', data, {
    params,
  });
}

/**
 * @description 统一用户状态修改
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/20775
 */
export function upsertUnifyUserChanageStatus(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/change_status', data, {
    params,
  });
}

/**
 * @description 用户身份分页查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/20777
 */
export function getUnifyUserIdentityPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/identity/page', data, {
    params,
  });
}

/**
 * @description 对比记录分页查询
 * @api https://yapi.ops.yunlizhi.cn/project/274/interface/api/29405
 */
export function getUnifyUserFaceHistoryPage(data, params) {
  return bfsUserWebHttp.post('/bfs_identity/face/compare_record/page', data, {
    params,
  });
}
/**
 * @description 用户身份分页查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/20777
 */
export function getUnifyUserIdentityList(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/identity/list', data, {
    params,
  });
}

/**
 * @description 修改用户身份状态(启用/禁用)
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/20793
 */
export function upsertUnifyUserIdentityPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/identity/change_status', data, {
    params,
  });
}

/**
 * @description 用户身份授权信息列表查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/20799
 */
export function getUnifyUserIdentityAuthList(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/identity/auth/list', data, {
    params,
  });
}

/**
 * @description 用户身份授权-重置密码
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/20801
 */
export function upsertUnifyUserIdentityAuthResetPwd(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/identity/auth/reset_pwd', data, {
    params,
  });
}

/**
 * @description 统一用户日志列表查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/20915
 */
export function getUnifyUserLogList(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/log/list', data, {
    params,
  });
}

/**
 * @description 统一用户日志分页查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/21305
 */
export function getUnifyUserLogPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/log/page', data, {
    params,
  });
}

/**
 * @description 统一用户 - 统一渠道列表查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/21297
 */
export function getUnifyChannelList(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/channel/list', data, {
    params,
  });
}

/**
 * @description 统一用户 - 统一渠道分页查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/21299
 * @param {Object} data
 * @param {string} data.id 渠道id
 * @param {string} data.name 渠道名称
 * @param {string} data.tag 渠道标识
 * @param {string} data.status 状态 ENABLED DISABLED
 */
export function getUnifyChannelPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/channel/page', data, {
    params,
  });
}

/**
 * @description 统一用户 - 新增或修改渠道信息
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/21301
 * @param {Object} data
 * @param {string} data.id 渠道id
 * @param {string} data.name 渠道名称
 * @param {string} data.tag 渠道标识
 * @param {string} data.status 状态 ENABLED DISABLED
 * @param {string} data.description 描述
 * @param {string} data.operatorId userId
 * @param {string} data.operatorName
 */
export function upsertUnifyChannel(data) {
  return bfsUserWebHttp.post('/bfs_user/unify/channel/upsert', data);
}

/**
 * @description 统一用户 - 修改渠道状态
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/21303
 * @param {Object} data
 * @param {string} data.id 渠道id
 * @param {string} data.status 需要修改的状态 ENABLED DISABLED
 * @param {string} data.operatorId userId
 * @param {string} data.operatorName
 */
export function unifyChannelStatusChange(data) {
  return bfsUserWebHttp.post('/bfs_user/unify/channel/status_change', data);
}

/**
 * @description 系统入口管理 - 分页列表
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/21253
 * @param {Object} data
 * @param {string} data.id 渠道id
 * @param {string} data.displayName 展示名称
 * @param {string} data.clientCode 客户端编码
 * @param {string} data.identity 身份
 * @param {string} data.url 跳转地址
 */
export function getPortalSystemPage(data, params) {
  return bfsUserWebHttp.post('/bfs_sso/portal_system/page', data, { params });
}

/**
 * @description 系统入口管理 - 修改/添加
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/21251
 * @param {Object} data
 */
export function upsertPortalSystem(data, params) {
  return bfsUserWebHttp.post('/bfs_sso/portal_system/upsert', data, { params });
}

/**
 * @description 系统入口管理 - 修改状态
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/21251
 * @param {Object} data
 * @param {string} data.id 主键,ID
 * @param {boolean} data.logic 是否逻辑删除
 * @param {string} data.operatorId 操作人ID
 * @param {string} data.operatorName 操作人名称
 * @param {string} data.status 状态  ENABLED DISABLED
 */
export function upsertPortalSystemStatus(data, params) {
  return bfsUserWebHttp.post('/bfs_sso/portal_system/status/update', data, { params });
}
/**
 * @description 系统入口管理 - 系统列表
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/5861
 * @param {Object} data
 */
export function getAdminClientSettingPage(data, params) {
  return bfsUserWebHttp.post('/bfs_sso/admin/client_setting/page', data, { params });
}

/**
 * @description 系统入口管理 - 获取系统日志
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/5861
 * @param {Object} data
 */
export function getSystemLogPage(data, params) {
  return bfsUserWebHttp.post('/bfs_sso/log/page', data, { params });
}

/**
 * @description 系统入口管理
 * @param {Object} data
 * @param {string} data.configKey SYSTEM_PORTAL_CATEGORY
 * @param {boolean} data.needConfigAttr true
 */
export function getConfigCenterPage(data, params) {
  return bfsUserWebHttp.post('/bfs-config/config_center/page', data, { params });
}

/**
 * @description 身份管理 - 身份列表查询
 * @param {Object} data
 */
export function getUnfiyIdentityList(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/identity/list', data, { params });
}

/**
 * @description 身份管理 - 分页
 * @param {Object} data
 */
export function getUnfiyIdentityPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/identity/page', data, { params });
}

/**
 * @description 身份管理 - 新增/修改身份信息
 * @param {Object} data
 */

export function upsertUnifyIdentity(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/identity/upsert', data, { params });
}
/**
 * @description 身份管理 - 新增/修改身份信息
 * @param {Object} data
 */

export function upsertUnifyDisabledSystemIdentity(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/identity/disabled_system/upsert', data, { params });
}

/**
 * @description 身份管理 - 新增/修改扩展信息
 * @param {Object} data
 */

export function upsertUnifyUserIdentityExtend(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/identity/extend/upsert', data, { params });
}

/**
 * @description 身份管理 - 身份状态修改
 * @param {Object} data
 */

export function upsertUnifyIdentityStatus(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/identity/status_change', data, { params });
}

/**
 * @description 系统入口管理 获取权限系统列表
 * @param {Object} data
 */

export function getPermissionSystemPage(data, params) {
  return bfsUserWebHttp.post('/permission-plus/system/page', data, { params });
}

/**
 * @description 登录授权 分页列表
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/21821
 * @param {Object} data
 */

export function getUnifyLoginAuthPage(data, params) {
  return bfsUserWebHttp.post('/bfs-user/unify/login_auth/page', data, { params });
}

/**
 * @description 登录授权 修改/添加
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/21819
 * @param {Object} data
 */

export function upsertUnifyLoginAuth(data, params) {
  return bfsUserWebHttp.post('/bfs-user/unify/login_auth/upsert', data, { params });
}

/**
 * @description 登录授权 变更状态
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/21823
 * @param {Object} data
 */

export function changeUnifyLoginAuthStatus(data, params) {
  return bfsUserWebHttp.post('/bfs-user/unify/login_auth/status/change', data, { params });
}

/**
 * @description 统一用户 修改认证标识
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/22203
 * @param {Object} data
 */

export function changeUnifyIdentityAuthIdentifier(data, params) {
  return bfsUserWebHttp.post('/bfs-user/unify/user/identity/auth/update/identifier', data, { params });
}

/**
 * @description 统一用户 批量踢用户下线
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/22261
 * @param {Object} data
 */

export function sessionBatchKickOut(data, params) {
  return bfsUserWebHttp.post('/bfs-sso/session/batch/kick_out', data, { params });
}

/**
 * @description 统一用户 通过统一账号ID查询原始账号日志
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/22287
 * @param {Object} data
 */

export function getOperatorLogPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/user/operator_log/page/by_unify_id', data, { params });
}
/**
 * @description 统一用户 补全手机号
 * @param {Object} data
 * @param {string} data.userId 统一用户ID
 * @param {string} data.repairType 补全类型，传：MOBILE
 * @param {string} data.repairMode 补全方式，传：NONE
 * @param {string} data.repairInfo 补全信息，传用户输入的手机号
 * @returns {Object} {success: true} 是否成功
 */

export function repairUnifyUser(data, params) {
  return bfsUserWebHttp.post('/bfs_user/unify/user/repair', data, { params });
}

/**
 * 人员库分页列表
 * https://yapi.ops.yunlizhi.cn/project/274/interface/api/29054
 */
export function userfacePage(data, params) {
  return otmsHttp.post('bfs_identity/user_face/config/page', data, { params });
}

/**
 * 人员库状态变更
 * https://yapi.ops.yunlizhi.cn/project/274/interface/api/29396
 */
export function userfaceChange(data) {
  return otmsHttp.post('bfs_identity/user_face/config/status/change', data);
}

/**
 * 人员录入|更新
 * https://yapi.ops.yunlizhi.cn/project/274/interface/api/29423
 */
export function userfaceEdit(data) {
  return otmsHttp.post('bfs_identity/face/user/upsert', data);
}

/**
 * 人员录入|更新
 * https://yapi.ops.yunlizhi.cn/project/274/interface/api/29513
 */
export function userFaceRegister(data) {
  return otmsHttp.post('bfs_identity/face/user/register', data);
}
